// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Y_yC","button--full-width":"Button_button--full-width__1oI1Q"};